export enum NotTakenForCareReasonEnum {
  Staffing = 1,
  SourceCancelled = 2,
  Insurance = 3,
  Area = 4,
  PatientRefused = 5,
  NotHomebound = 6,
  PatientHospitalized = 7,
  ReferralOrderExpired = 8,
  DifferentAgency = 9,
  Other = 99
}

export const NotTakenForCareReasonOptions = [
{ id: 1, label: 'Staffing' },
{ id: 2, label: 'Referral Source Cancelled' },
{ id: 3, label: 'Insurance' },
{ id: 4, label: 'Out of Area' },
{ id: 5, label: 'Patient Refused Services' },
{ id: 6, label: 'Not Homebound' },
{ id: 7, label: 'Patient Hospitalized' },
{ id: 8, label: 'Referral Order Expired' },
{ id: 9, label: 'Admitted to other HHA' },
{ id: 99, label: 'Other' }
];
